import { render, staticRenderFns } from "./TransactionHistory.vue?vue&type=template&id=6af6f236&scoped=true&"
import script from "./TransactionHistory.vue?vue&type=script&lang=js&"
export * from "./TransactionHistory.vue?vue&type=script&lang=js&"
import style0 from "./TransactionHistory.vue?vue&type=style&index=0&id=6af6f236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af6f236",
  null
  
)

component.options.__file = "TransactionHistory.vue"
export default component.exports